import React from 'react';
import ClassAssembly  from 'views/ClassAssembly10A2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;